module.exports = __webpack_public_path__ + "static/media/modules.89e0c698.png";